import React from "react"

function Header(){
	return (
		<header>
			<img src="logo192.png"
			alt="problem?!"
			/>
			<p> Meme Generator </p>
		</header>
	)


	
}
	
export default Header